// src/pages/FormPage/renderers/LoadingForm.jsx
import React from 'react';

const ThankYou = ({schemaTY}) => (
  <div className="fixed flex justify-center items-center w-full top-5" role="alert">
  <div className="max-w-xs flex items-center p-2 text-green-700 bg-white rounded-lg shadow dark:text-green-400 dark:bg-gray-800">
    <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500 bg-green-100 rounded-lg dark:bg-green-700 dark:text-green-200">
      <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
      </svg>
      <span className="sr-only">Success icon</span>
    </div>
    <div className="ms-3 text-sm font-normal">
      <h2>{schemaTY?.title || 'Obrigado!'}</h2>
      <p>{schemaTY?.subtitle || 'As respostas foram enviadas com sucesso.'}</p>
    </div>
  </div>
</div>

);

export default ThankYou;
